import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../App";

// My Queue — assets whose current stage is the caller's turn. Derived live from
// the pipeline (no data entry). Reads /api/ptracker/queue.

const TYPE_COLOR = {
  reel: "#3B82F6", ad_film: "#A855F7", story: "#EC4899", performance: "#10B981",
  thumbnail: "#06B6D4", static: "#22C55E", carousel: "#F59E0B",
};
const ROLE_LABEL = {
  producer: "Producer", creative_lead: "Creative Lead", director: "Director",
  writer: "Writer", editor: "Editor", designer: "Designer",
};
const mono = "var(--font-mono)";

export default function PtrackerQueue() {
  const [assets, setAssets] = useState(null);
  const [err, setErr] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    let alive = true;
    api.get("/ptracker/queue")
      .then((r) => { if (alive) setAssets(r.data.assets || []); })
      .catch((e) => { if (alive) setErr(e.response?.data?.detail || "Couldn't load your queue."); });
    return () => { alive = false; };
  }, []);

  const card = {
    display: "flex", alignItems: "center", gap: 14, background: "var(--s1)",
    border: "1px solid var(--bdr)", borderRadius: "var(--radius-sm)", padding: "14px 16px",
    cursor: "pointer", transition: "transform .15s",
  };

  return (
    <div style={{ padding: "24px 28px", maxWidth: 900, margin: "0 auto" }} data-testid="ptracker-queue">
      <h1 style={{ fontFamily: "var(--font-heading, var(--font-orb))", fontSize: 30, fontWeight: 700, color: "var(--t1)", letterSpacing: "-.01em", margin: 0, textTransform: "uppercase" }}>My Queue</h1>
      <p style={{ fontFamily: mono, fontSize: 12, color: "var(--t3)", letterSpacing: ".04em", marginTop: 4, marginBottom: 20 }}>
        What's your turn — derived live from the pipeline. Nothing to fill in.
      </p>

      {err && <div style={{ color: "var(--r)", fontFamily: mono, fontSize: 12 }}>{err}</div>}

      {assets && assets.length === 0 && (
        <div style={{ border: "1px dashed var(--bdr)", borderRadius: "var(--radius-sm)", padding: "40px 0", textAlign: "center", fontFamily: mono, fontSize: 13, color: "var(--t3)" }}>
          Nothing waiting on you right now. 🎬
        </div>
      )}

      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        {(assets || []).map((a) => (
          <div
            key={a.asset_id}
            style={card}
            onClick={() => navigate("/production")}
            onMouseEnter={(e) => (e.currentTarget.style.transform = "translateY(-2px)")}
            onMouseLeave={(e) => (e.currentTarget.style.transform = "none")}
          >
            <span style={{ fontFamily: mono, fontSize: 9, fontWeight: 700, color: TYPE_COLOR[a.asset_type] || "var(--t3)", background: "var(--s2)", borderRadius: 4, padding: "5px 8px", letterSpacing: ".06em", textTransform: "uppercase" }}>
              {a.asset_type}
            </span>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontFamily: "var(--font-sans)", fontSize: 14, fontWeight: 600, color: "var(--t1)" }}>{a.title}</div>
              <div style={{ fontFamily: mono, fontSize: 11, color: "var(--t3)", marginTop: 2 }}>
                {a.client} · your role: {ROLE_LABEL[a.owner_role] || a.owner_role}
              </div>
            </div>
            {a.stage_age_days >= 5 && (
              <span style={{ fontFamily: mono, fontSize: 10, fontWeight: 700, color: "var(--r)", background: "var(--rd)", borderRadius: 10, padding: "3px 8px" }}>
                {a.stage_age_days}d waiting
              </span>
            )}
            <span style={{ fontFamily: mono, fontSize: 10, color: "var(--t2)", background: "var(--s2)", borderRadius: 3, padding: "3px 8px", letterSpacing: ".06em", textTransform: "uppercase" }}>{a.status}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
